import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface NotificationData {
  id: number;
  message: string;
  viewed: boolean;
  category: string;
}

@Component({
  selector: 'app-notification-list-item',
  templateUrl: './notification-list-item.component.html',
  styleUrls: ['./notification-list-item.component.scss']
})
export class NotificationListItemComponent {
  @Input() notification: NotificationData;
  @Input() showViewer: boolean = false;

  @Output() remove = new EventEmitter<number>();

  onRemove(): void {
    this.remove.emit(this.notification.id);
  }

  get categoryLabel(): string {
    return this.notification.category
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  getCategoryColor(): string {
    const categoryColors: { [key: string]: string } = {
      'WELCOME_LEADER': 'primary',
      'CHALLENGE_COMPLETED': 'success',
      'NEW_CHALLENGE': 'info',
      'ROLE_ASSIGNMENT': 'warning',
      'DEFAULT': 'secondary'
    };

    return categoryColors[this.notification.category] || categoryColors['DEFAULT'];
  }

  getCategoryIcon(): string {
    const categoryIcons: { [key: string]: string } = {
      'WELCOME_LEADER': 'star',
      'CHALLENGE_COMPLETED': 'check_circle',
      'NEW_CHALLENGE': 'assignment',
      'ROLE_ASSIGNMENT': 'person_add',
      'DEFAULT': 'notifications'
    };

    return categoryIcons[this.notification.category] || categoryIcons['DEFAULT'];
  }
}
